import { LOGIN_NAVIGATION_MAP } from '../components/LoginNavigation/constants';
import { mfaType } from '../../../types';
import { ValidateFieldTypes, validationSchemeMap } from '../../../helpers/inputUtils.helper';

export const MFA_TYPE = {
  SMS: 'SMS' as mfaType,
  EMAIL: 'EMAIL' as mfaType,
  VOICE: 'VOICE' as mfaType,
};

export const LOGIN_ERROR_POPUP = {
  HEADER: 'LOGIN_ERROR_POPUP_HEADER',
  ERROR_TEXT: 'LOGIN_ERROR_POPUP_TEXT',
  BUTTON_TEXT: 'LOGIN_ERROR_POPUP_BUTTON_TEXT',
} as const;

export const WELCOME_TO_LILI_SCREEN_DATA = {
  CONTAINER: {
    CLASS_NAME: 'relative m-auto flex flex-col m-auto',
    // consider support for responsive heights
  },
  LOGIN_CARD: {
    CLASS_NAME: 'm-auto relative bg-bw00',
  },
  HEADING: {
    TITLE: 'WELCOME_PAGE_HEADER',
    CLASS_NAME: 'w-96 heading text-bw08 mb-4 font-metricSemibold',
  },
  LOGIN_BTN: {
    TITLE: 'WELCOME_PAGE_LOGIN_BTN_TEXT',
    CLASS_NAME: 'max-w-[100%] mt-auto h-12',
    INVALID_CLASS_NAME: 'max-w-[100%] mt-auto',
  },
  I_NEED_HELP_BTN: {
    TITLE: 'WELCOME_PAGE_I_NEED_HELP_BTN_TEXT',
    CLASS_NAME:
      'block font-metricMedium m-auto cursor-pointer text-sm text-action03 mt-4 text-center hover:text-action04',
  },
  NEW_TO_LILI: {
    CONTAINER: {
      CLASS_NAME: 'font-metricMedium mt-4 justify-center flex text-center',
    },
    TEXT: {
      CLASS_NAME: 'text-center text-bw07 text-sm pr-1',
      TITLE: 'WELCOME_PAGE_NEW_TO_LILI',
    },
    APPLY_NOW_BTN: {
      TITLE: 'WELCOME_PAGE_NEW_APPLY_NOW_BUTTON',
      CLASS_NAME: 'text-sm text-action03 hover:text-action04',
    },
  },
  INPUTS: [
    {
      TITLE: 'WELCOME_PAGE_INPUT_EMAIL_PLACEHOLDER',
      TYPE: 'email',
      VALIDATION: validationSchemeMap[ValidateFieldTypes.EMAIL],
      ERROR: 'WELCOME_PAGE_INPUT_EMAIL_ERROR',
      AUTOCOMPLETE: 'username email',
    },
    {
      TITLE: 'WELCOME_PAGE_INPUT_PASSWORD_PLACEHOLDER',
      TYPE: 'password',
      VALIDATION: /^.{6,}$/,
      ERROR: 'WELCOME_PAGE_INPUT_PASSWORD_ERROR',
      AUTOCOMPLETE: 'new-password',
    },
  ],
  ACTIONS: {
    VERIFY_IS_NEEDED: LOGIN_NAVIGATION_MAP.VERIFICATION_CODE,
    SUCCESS: LOGIN_NAVIGATION_MAP.HOME,
    FAILURE: undefined,
    BACK: undefined,
  },
};

export const RESEND_VERIFICATION_SCREEN_DATA = {
  LOGIN_CARD: {
    CLASS_NAME: 'top-[calc(50%-348px/2-82px)] left-[calc(50%-410px/2)] bg-bw00',
  },
  HEADING: {
    TITLE: 'RESEND_VERIFICATION_CODE_PAGE_HEADER',
    CLASS_NAME: 'heading font-metricSemibold text-bw08 mb-2',
  },
  TEXT: {
    TITLE: 'RESEND_VERIFICATION_CODE_PAGE_TEXT',
    CLASS_NAME: 'font-metric text-base text-bw07 mb-4',
  },
  RADIO_BUTTONS: [
    {
      ID: 'message',
      TITLE: 'RESEND_VERIFICATION_CODE_PAGE_BUTTON_SMS',
      BUTTON_TITLE: 'RESEND_VERIFICATION_CODE_PAGE_BUTTON_SMS_TEXT',
      TYPE: MFA_TYPE.SMS,
      CHECKED: true,
    },
    {
      ID: 'call',
      TITLE: 'RESEND_VERIFICATION_CODE_PAGE_BUTTON_CALL',
      BUTTON_TITLE: 'RESEND_VERIFICATION_CODE_PAGE_BUTTON_CALL_TEXT',
      TYPE: MFA_TYPE.VOICE,
    },
  ],
  LOGIN_BTN: {
    CLASS_NAME: 'text-sm mt-4 text-bw00 bg-action03 w-full h-12 rounded font-metricRMedium hover:bg-action04',
  },
  ACTIONS: {
    SUCCESS: LOGIN_NAVIGATION_MAP.VERIFICATION_CODE,
    FAILURE: undefined,
    BACK: LOGIN_NAVIGATION_MAP.VERIFICATION_CODE,
  },
} as const;

export const DIGITS_CONTAINER_DATA = {
  CONTAINER: {
    CLASS_NAME: 'flex justify-between gap-2.5 mt-7 mb-3',
  },
  DIGIT_CONTAINER: {
    CLASS_NAME:
      'w-[43px] h-[58px] text-2xl text-center text-action03 rounded-md  font-metricR focus:shadow-shadowAction03 focus:border-action03 focus:bg-bw00 border-[2px] border-bw03  caret-action03 !outline-none',
    FILLED_INPUT: '!outline-none !border-action03',
    VALIDATION_FAILED: '!border-red02 !bg-red00',
    LOADING_IN_PROCESS: 'border-bw03',
    INITIAL_FRAMES: 'border-bw03  bg-bw02',
  },
  KEYBOARD_EVENT_DIGITS: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
} as const;

export const VERIFICATION_CODE_PAGE_DATA = {
  LOGIN_CARD: {
    CLASS_NAME: 'top-[calc(50%-348px/2-82px)] left-[calc(50%-410px/2)] w-[25.625rem] h-fit bg-bw00',
  },
  ERROR_MESSAGE_CLASS_NAME: 'h-[1rem] font-metric text-red02 text-sm text-center mb-4',
  HEADER_VERIFICATION_CODE: {
    TITLE: 'VERIFICATION_CODE_PAGE_HEADER',
    CLASS_NAME: 'w-96 heading font-metricSemibold text-bw08 mb-4 mt-[0.375rem]',
  },
  TEXT_ROW_1: {
    TITLE: 'VERIFICATION_CODE_PAGE_TEXT_1',
    CLASS_NAME: 'font-metric text-base text-bw08',
  },
  TEXT_ROW_2: {
    TITLE: 'VERIFICATION_CODE_PAGE_TEXT_2',
    CLASS_NAME: 'font-metric text-base text-bw08',
  },
  TEXT_ROW_3: {
    CONTAINER: {
      CLASS_NAME: 'flex items-center justify-center',
    },
    TITLE: 'VERIFICATION_CODE_PAGE_DID_NOT_RECEIVE',
    CLASS_NAME: 'text-center font-metricMedium text-bw07 text-sm pr-1',
    INTERNAL_BUTTON: {
      TITLE: 'VERIFICATION_CODE_PAGE_RESEND_CODE',
      CLASS_NAME: 'text-action03 font-metricMedium text-sm hover:text-action04',
    },
  },
  NUM_OF_DIGITS_SMS: 6,
  NUM_OF_DIGITS_VOICE: 5,
  MFA_VOICE: 'VOICE',
  MFA_SMS: 'SMS',
  ACTIONS: {
    SUCCESS: LOGIN_NAVIGATION_MAP.RESEND_VERIFICATION,
    FAILURE: undefined,
    BACK: LOGIN_NAVIGATION_MAP.WELCOME,
  },
} as const;

export const TIMER_SCREEN_DATA = {
  LOGIN_CARD: {
    CLASS_NAME: 'w-[50%] min-w-[24rem] left-[20%] top-[20%]',
    BACKGROUND: 'bg-transparent',
  },
  HEADING: {
    TITLE: 'TAKE_5_PAGE_HEADER',
    CLASS_NAME: 'w-96 max-w-[300px] heading text-bw08 font-metricSemibold mb-4',
  },
  TEXT: {
    TITLE_ROW_1: 'TAKE_5_PAGE_TEXT_1',
    TITLE_ROW_2: 'TAKE_5_PAGE_TEXT_2',
    CLASS_NAME: 'text-bw07 font-metric mb-1 max-w-[490px]',
  },
} as const;

export const HELP_SCREEN_DATA = {
  LOGIN_CARD: {
    CLASS_NAME: 'w-[50%] min-w-[24rem] left-[20%] top-[20%]',
    BACKGROUND: 'bg-transparent',
  },
  HEADING: {
    TITLE: 'NEED_HELP_PAGE_HEADER',
    CLASS_NAME: 'w-96 heading text-bw08 font-metricSemibold',
  },
  TEXT: {
    TITLE: 'NEED_HELP_PAGE_TEXT',
    CLASS_NAME: 'text-base mt-4 mb-4 text-bw07 font-metricMedium',
  },
  GRID: {
    HEADING: {
      TITLE: 'NEED_HELP_PAGE_LIST_HEADER',
      CLASS_NAME: 'mb-2 text-bw07 font-metric',
    },
    DOT_1: {
      NUMBER: '1',
      TITLE: 'NEED_HELP_PAGE_DOT_1_TEXT',
    },
    DOT_2: {
      NUMBER: '2',
      TITLE: 'NEED_HELP_PAGE_DOT_2_TEXT',
    },
    DOT_3: {
      NUMBER: '3',
      TITLE: 'NEED_HELP_PAGE_DOT_3_TEXT',
    },
  },
} as const;

export const HELP_SCREEN_DATA_NEW = {
  LOGIN_HELP_CARD: {
    CLASS_NAME: 'top-[calc(50%-348px/2-82px)] left-[calc(50%-410px/2)] w-[456px] h-[496px] bg-bw00',
    BACKGROUND: 'bg-transparent',
  },
  HEADING: {
    TITLE: 'LOGIN_HELP_PAGE.HEADER_TEXT',
    CLASS_NAME: 'heading text-bw08 font-metricRBold text-[24px]',
  },
  DESCRIPTION: {
    TITLE: 'LOGIN_HELP_PAGE.DESCRIPTION_TEXT',
    CLASS_NAME: 'text-base mt-4 mb-[26px] text-bw08 font-metricR',
  },
  OPTIONS: {
    STYLE: {
      CONTAINER: {
        CLASS_NAME:
          ' flex align items-center justify-between  py-[12px]   border  rounded-lg my-[14px] p-[12px] hover:border-action03 hover:shadow-bottomShadow hover:cursor-pointer',
      },
      HEADING: {
        CLASS_NAME: ' my-[8px] font-metricRMedium text-[16px]',
      },
    },
    FORGOT_EMAIL: {
      TITLE: 'LOGIN_HELP_PAGE.OPTION.FORGOT_EMAIL_TEXT',
    },
    FORGOT_PASSWORD: {
      TITLE: 'LOGIN_HELP_PAGE.OPTION.FORGOT_PASSWORD_TEXT',
    },
    CHANGE_PHONE: {
      TITLE: 'LOGIN_HELP_PAGE.OPTION.CHANGE_PHONE_TEXT',
    },
  },
  ACTIONS: {
    SUCCESS: undefined,
    FAILURE: undefined,
    BACK: LOGIN_NAVIGATION_MAP.HELP,
  },
} as const;
export const NOT_FINISHED_SIGN_UP_SCREEN_DATA = {
  LOGIN_CARD: {
    CLASS_NAME: 'w-[50%] min-w-[24rem] left-[20%] top-[20%]',
    BACKGROUND: 'bg-transparent',
  },
  HEADING: {
    TITLE: 'NOT_FINISHED_SIGN_UP_PAGE_HEADER',
    CLASS_NAME: 'w-[30rem] heading text-bw08 font-metricSemibold',
  },
  TEXT: {
    TITLE: 'NOT_FINISHED_SIGN_UP_PAGE_TEXT',
    CLASS_NAME: 'w-[21rem] text-base mt-2 mb-6 text-bw07 font-metric',
  },
  LOGIN_BTN: {
    TITLE: 'NOT_FINISHED_SIGN_UP_PAGE_BUTTON_TEXT',
    CLASS_NAME: 'w-40 font-metricBold leading-4 tracking-wide hover:bg-action04',
  },
  ACTIONS: {
    SUCCESS: undefined,
    FAILURE: undefined,
    BACK: LOGIN_NAVIGATION_MAP.WELCOME,
  },
} as const;

export const SIGN_UP_URL = 'https://prod.lili.co/index.html';

export const BACK_BUTTON_STYLE = {
  CONTAINER: {
    CLASS_NAME: 'bg-bw02 h-screen m-screen content-center m-auto',
  },
  CLASS_NAME:
    'absolute top-0 left-0 mt-[3.75rem] ml-[3.75rem] w-[2.5rem] h-[2.5rem] border box-border border-solid rounded-md border-bw05 flex items-center justify-center',
};

export const TAKE_A_BREAK_SCREEN = {
  HEADER: 'TOOK_A_BREAK_PAGE_HEADER',
  TEXT: 'TOOK_A_BREAK_PAGE_TEXT',
  BUTTON: 'TOOK_A_BREAK_PAGE_BUTTON_TEXT',
} as const;

export const FORGOT_EMAIL = {
  LOGIN_HELP_CARD: {
    CLASS_NAME: 'top-[calc(50%-348px/2-82px)] left-[calc(50%-410px/2)] w-[456px] h-[496px] bg-bw00',
    BACKGROUND: 'bg-transparent',
  },
  HEADING: {
    TITLE: 'LOGIN_HELP_PAGE.HEADER_TEXT',
    CLASS_NAME: 'heading text-bw08 font-metricRBold text-[24px]',
  },
  DESCRIPTION: {
    TITLE: 'LOGIN_HELP_PAGE.DESCRIPTION_TEXT',
    CLASS_NAME: 'text-base mt-4 mb-[26px] text-bw08 font-metricR',
  },

  ACTIONS: {
    SUCCESS: undefined,
    FAILURE: undefined,
    BACK: LOGIN_NAVIGATION_MAP.HELP,
  },
} as const;
export const USER_BLOCKED_CODE = 4026;
export const LOCKED_OUT = 'LOCKED_OUT';
